import { buildLegend } from "@features/sales-v3/utils/tooltip";

export const REVENUE_ID = "Revenue";
export const REVENUE_COLOR = "#7081FF";
export const REVENUE_LEGEND = buildLegend(
  {
    borderColor: REVENUE_COLOR,
    backgroundColor: REVENUE_COLOR,
    borderDash: [],
  },
  false,
);

export const ROAS_ID = "ROAS";
export const ROAS_COLOR = "#7081FF";
export const ROAS_BORDER_DASH = [5, 3];
export const ROAS_LEGEND = buildLegend(
  {
    borderColor: ROAS_COLOR,
    backgroundColor: ROAS_COLOR,
    borderDash: ROAS_BORDER_DASH,
  },
  false,
);

export const OBSERVED_SPEND_ID = "Observed Spend";
export const OBSERVED_SPEND_COLOR = "rgba(113, 118, 128, 0.15)";
export const OBSERVED_SPEND_LEGEND = buildLegend(
  {
    borderColor: OBSERVED_SPEND_COLOR,
    backgroundColor: OBSERVED_SPEND_COLOR,
    borderDash: [],
  },
  true,
);

export type DataColumn = {
  column_name: string;
  breakdowns: { key: string; value: string }[];
  label: string;
  spend: number;
};
